module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02.de0ef19adedf3aff56e929079476070c.png";